export default __webpack_public_path__ + "static/media/infinity.c3b60aa3.svg";